import React, { FC, useContext, useEffect, useState } from 'react';
import { MyPagesContext } from '~js/React/pages/Context/MyPagesContext';
import { getSessionFlagWithExpiry, getSessionId } from '~js/React/helpers';
import { ConsentEnums } from '~js/React/Enums';
import useConsent from '../../../CustomHooks/useConsent';
const ConsentHandler = React.lazy(() => import('./ConsentHandler'));
const ConsentModal = React.lazy(() => import('./ConsentModal'));

type Props = {
  isEditPage: boolean;
  isCompleteProfilePage: boolean;
};

const Consent: FC<Props> = ({ isEditPage, isCompleteProfilePage }) => {
  const modalIsDismissed = getSessionFlagWithExpiry(ConsentEnums.DismissedKey);
  if (modalIsDismissed && !isEditPage) return null;

  const { user, sessionId } = useContext(MyPagesContext);
  if (!sessionId) return null; // Make sure user is logged in

  const [vitecSsn, setVitecSsn] = useState<string | null>(null);

  useEffect(() => {
    setVitecSsn(user?.vitecPerson?.socialSecurityNumber);
  }, [user]);

  // Get potential consent and consentAnswers
  const { consent, consentAnswers, refetch } = useConsent(sessionId);

  return sessionId && vitecSsn ? (
    <>
      {!isEditPage && !isCompleteProfilePage && consent && (
        <ConsentModal
          consent={consent}
          ssn={vitecSsn}
          modalIsDissmissed={modalIsDismissed}
          sessionId={sessionId}
        />
      )}

      {isEditPage && (
        <ConsentHandler
          consent={consent}
          consentAnswers={consentAnswers}
          ssn={vitecSsn}
          refetch={refetch}
          sessionId={sessionId}
        />
      )}
    </>
  ) : null;
};

export default Consent;
